const rootActionPath = 'core/MediaQueries';

export const MEDIA_QUERIES_UPDATE = `${rootActionPath}`;
